export function mapOrderPassengerToBookingTraveler(passenger) {
  const nationality = passenger?.document?.nationality || "";

  return {
    _id: `copied-${passenger?.id || ""}-${passenger?.lastName || ""}-${passenger?.firstName || ""}-${passenger?.birthDate || ""}`,
    firstName: passenger?.firstName || "",
    middleName: passenger?.middleName || "",
    lastName: passenger?.lastName || "",
    birthDate: passenger?.birthDate || "",
    gender: passenger?.gender || "",
    frequentFlyer:
      passenger?.frequentFlyer ||
      passenger?.document?.frequentFlyerNo ||
      "",
    document: {
      documentType: passenger?.document?.documentType || "Passport",
      number: passenger?.document?.number || "",
      expiryDate: passenger?.document?.expiryDate || "",
      nationality,
      issuanceCountry:
        passenger?.document?.issuanceCountry || nationality,
      validityCountry: passenger?.document?.validityCountry || nationality,
      birthPlace: passenger?.document?.birthPlace || nationality,
      issuanceLocation:
        passenger?.document?.issuanceLocation || nationality,
      issuanceDate: passenger?.document?.issuanceDate || "",
      holder: true,
    },
    email: passenger?.email || "",
    phone: passenger?.phone || "",
    copiedFromOrder: true,
  };
}

export function getCopiedPassengerKey(passenger) {
  return [
    passenger?.lastName,
    passenger?.firstName,
    passenger?.birthDate,
  ]
    .map((value) => String(value || "").trim().toLowerCase())
    .join("|");
}
